import { CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { BaseComponent } from './BaseComponent';
import styles from './TefComsLoader.css';

@customElement('tef-coms-loader')
export class TefComsLoader extends BaseComponent {
  @property({ type: Boolean }) cloak : boolean = false;

  static readonly styles = styles as unknown as CSSResultGroup;

  override render() {
    return this.getTemplateFn('tefComsLoader')();
  }
}
